import sessionReader from '../../store/readHelpers/SessionReader';
import objectTypes from '../../constants/ObjectTypes';
import constants from '../../qti/Constants';

function itemBodyIncludes(someString) {
    return question => question.itemBody && question.itemBody.includes(someString);
}

function itemBodyIncludesAnyOf(someStrings) {
    return question => question.itemBody && someStrings.some(someString => question.itemBody.includes(someString));
}

function notPrintOrPdf() {
    return !sessionReader.isViewMediaPrintOrPdf();
}

function isObjectType(objectType) {
    return question => question.objectType === objectType;
}

const requirementsParser = {
    /**
     * Checks if Ace Editor is required for any of the questions.
     * @param {Array} questions - The list of questions to check.
     * @returns {boolean} - True if Ace Editor is required.
     */
    isAceEditorRequired(questions) {
        return questions.some((question) => {
            return isObjectType(objectTypes.CODE_EDITOR)(question)
                || isObjectType(objectTypes.COMPILED_CODE_EDITOR)(question);
        });
    },

    /**
     * Checks if CKEditor is required for a specific question.
     * @param {Object} question - The question to check.
     * @returns {boolean} - True if CKEditor is required for this question.
     */
    isCkEditorRequiredForQuestion(question) {
        return isObjectType(objectTypes.EXTENDED_TEXT)(question)
            && itemBodyIncludes('usePlainText="false"')(question);
    },

    /**
     * Checks if CKEditor is required for any of the questions in the assessment.
     * @param {Array} questions - The list of questions to check.
     * @returns {boolean} - True if CKEditor is required.
     */
    isCkEditorRequired(questions) {
        return notPrintOrPdf()
            && questions.some((question) => {
                return this.isCkEditorRequiredForQuestion(question);
            });
    },

    /**
     * Checks if PDF.js is required for any of the questions.
     * @param {Array} questions - The list of questions to check.
     * @returns {boolean} - True if PDF.js is required.
     */
    isPdfJsRequired(questions) {
        return notPrintOrPdf()
            && questions.some(itemBodyIncludes('id="pdfView"'));
    },

    /**
     * Checks if MathJax is required for any of the questions.
     * @param {Array} questions - The list of questions to check.
     * @returns {boolean} - True if MathJax is required.
     */
    isMathJaxRequired(questions) {
        return questions.some(itemBodyIncludesAnyOf(['<span class="math-tex">', '<span class="LaTeX">']));
    },

    /**
     * Checks if Symbola font is required for any of the questions.
     * @param {Array} questions - The list of questions to check.
     * @returns {boolean} - True if Symbola font is required.
     */
    isSymbolaFontRequired(questions) {
        return notPrintOrPdf()
            && questions.some(isObjectType(objectTypes.MATH_ENTRY));
    },

    /**
     * Checks if any of the questions are Symbolic Math questions.
     * @param {Array} questions - The list of questions to check.
     * @returns {boolean} - True if at least one question is a Symbolic Math question.
     */
    isSymbolicMathRequired(questions) {
        return questions.some(isObjectType(constants.objectType.SYMBOLIC_MATH));
    },
};

export default requirementsParser;
